import axios from 'axios';

export const cartPageLineitemchange = () => {
  document.addEventListener('DOMContentLoaded', async () => {
    const response = await getCart();
    const cartContent = response.data;
    const cartItems = cartContent.items;

    let refresh = false;

    // customizeの数を準備
    let numberOfCustomize = 0;

    const promises = cartItems.map(async (item) => {
      //____________________________________________________
      // CUSTOMIZE HAKUOSHI
      //____________________________________________________
      let colorProperty = null;
      let lettersProperty = null;
      let preOrderProperty = null;

      if (item.properties) {
        colorProperty = Object.keys(item.properties).find(
          (key) => key.includes('Color') && item.properties['Color'] != ''
        );
        lettersProperty = Object.keys(item.properties).find(
          (key) => key.includes('Letters') && item.properties['Letters'] != ''
        );
        preOrderProperty = Object.keys(item.properties).find(
          (key) => key.includes('Preorder') && item.properties['Preorder'] != ''
        );
      }

      // カスタマイズ箔押しの不備があった場合に、Lineitemの削除を行う
      // 色が無い場合, 文字が無い場合
      if (colorProperty && !lettersProperty && preOrderProperty) {
        // 色が無い場合, 文字が無い場合かつ予約などのLineItemPropertyがある場合
        // 予約の日時は残して箔押し分だけ削除
        const key = item.key;
        const properties = {};
        properties['Preorder'] = item.properties['Preorder'];
        const response = await addLineItemProperty(key, properties);
        refresh = true;
      } else if (!colorProperty && lettersProperty && preOrderProperty) {
        // 色が無い場合, 文字が無い場合かつ予約などのLineItemPropertyがある場合
        // 予約の日時は残して箔押し分だけ削除
        const key = item.key;
        const properties = {};
        properties['Preorder'] = item.properties['Preorder'];
        const response = await addLineItemProperty(key, properties);
        refresh = true;
      } else if (colorProperty && !lettersProperty) {
        // itemの削除と同じitemの追加
        const key = item.key;
        const variantId = item.id;
        await removeLineItem(key);
        await addLineItem(variantId);
        refresh = true;
      } else if (!colorProperty && lettersProperty) {
        // itemの削除と同じitemの追加
        const key = item.key;
        const variantId = item.id;
        await removeLineItem(key);
        await addLineItem(variantId);
        refresh = true;
      }

      // カスタマイズ箔押しがあった場合、上記の不備がなければ箔押し納期の追加
      // カスタマイズ箔押しがあった場合、LineItemに「custom-1」を一個だけ追加
      if (colorProperty && lettersProperty) {
        numberOfCustomize += 1;
        // 箔押し納期の追加
        const key = item.key;
        const thisItem = cartItems.find((item) => item.key == key);
        const properties = thisItem.properties;
        const deliveryProperty = Object.keys(properties).find(
          (key) => key.includes('納期') && item.properties['納期'] != ''
        );
        const preOrderProperty = Object.keys(properties).find(
          (key) => key.includes('Preorder') && item.properties['Preorder'] != ''
        );

        // 予約商品ではないとき
        if (!deliveryProperty && !preOrderProperty) {
          properties['納期'] = '約1週間';
          const response = await addLineItemProperty(key, properties);
          refresh = true;
        }

        // 予約商品のとき
        if (!deliveryProperty && preOrderProperty) {
          if (!item.properties['Preorder'].includes('+箔押し: 納期約1週間')) {
            item.properties['Preorder'] =
              item.properties['Preorder'] + '+箔押し: 納期約1週間';
            const response = await addLineItemProperty(key, properties);
            refresh = true;
          }
        }

        // LineItemに「custom-1」がなかったら、一個だけ追加
        const custom1 = document.querySelector('[data-customize-id]');
        if (custom1) {
          const custom1Id = custom1.dataset.customizeId;
          const hasCustom1 = cartItems.some((item) => item.id == custom1Id);
          if (!hasCustom1) {
            const reaponse = await addLineItem(custom1Id);
            refresh = true;
          }
        }
      }

      //____________________________________________________
      // GIFT WRAPPING
      //____________________________________________________
      // GIFT WRAPPINGの商品が単体でカートに追加されたら、削除する
      if (item.sku.includes('GIFT-')) {
        if (!cartItems.some((item) => !item.sku.includes('GIFT-'))) {
          const key = item.key;
          const response = await removeLineItem(key);
          refresh = true;
        }
      }
    });

    await Promise.all(promises);

    // もしカスタマイズ箔押しが削除された場合は、「custom-1」も削除する
    if (cartItems.some((item) => item.sku == 'custom-1')) {
      if (numberOfCustomize <= 0) {
        const custom1 = document.querySelector('[data-customize-id]');
        if (custom1) {
          const custom1Id = custom1.dataset.customizeId;
          const custom1Element = cartItems.find((item) => item.id == custom1Id);
          if (custom1Element) {
            const custom1Key = custom1Element.key;
            const reaponse = await removeLineItem(custom1Key);
            refresh = true;
          }
        }
      }
    }

    if (refresh) {
      await refreshCart();
    }
  });
};

const removeLineItem = async (key) => {
  const data = {
    updates: {
      [key]: 0,
    },
  };
  return await axios({
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    url: '/cart/update.js',
    data: data,
  });
};

const addLineItem = async (variantId) => {
  const formData = {
    items: [
      {
        id: variantId,
        quantity: 1,
      },
    ],
  };
  return await axios({
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    url: '/cart/add.js',
    data: formData,
  });
};

const addLineItemProperty = async (key, propertyData) => {
  const formData = {
    id: key,
    properties: propertyData,
  };
  return await axios({
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    url: '/cart/change.js',
    data: formData,
  });
};

const refreshCart = () => {
  window.location.reload();
};

const getCart = async () => {
  return await axios({
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'GET',
    url: '/cart.js',
  });
};
